// export default OrderList;
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import AddToCartModal from "../Admin/AddtoCartModal";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/solid";
import { FaEye } from "react-icons/fa";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { api_url } from "../config/config";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeletePrompt from "../Components/common/DeletePrompt";
const PrescriptionList = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [prescriptionToDelete, setPrescriptionToDelete] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showStatusHistoryModal, setShowStatusHistoryModal] = useState(false);
  const [showViewCart, setShowViewCart] = useState(false);
  const [showCartItem, setShowCartItem] = useState()
  const [statusHistoryPrescription, setStatusHistoryPrescription] =
    useState(null);
  const [viewPrescription, setViewPrescription] = useState(null);
  const tableRef = useRef(null);
  const [filters, setFilters] = useState({
    date: "",
    status: "",
  });
  const [orders, setOrders] = useState([]);
  const token = localStorage.getItem("admin_token");
  const role = localStorage.getItem("roles");
  const [newStatus, setNewStatus] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectionComments, setRejectionComments] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [debouncedFilters, setDebouncedFilters] = useState(filters); // Store the debounced filter values
  const [trigger, setTrigger] = useState(false);
  const [userPrescriptions, setUserPrescriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorStates, setErrorStates] = useState({});
const[comments, setComments] = useState("");
  const [showAddToCartModal, setShowAddToCartModal] = useState(false);
  const [selectedPrescriptionForCart, setSelectedPrescriptionForCart] = useState(null);
     const statusOptions = {
      
  // Pending: "Pending",
  InReview: "In Review",
  Approved: "Approved",
  Rejected: "Rejected",
  Cancelled: "Cancelled"
};


  const handleImageError = (id) => {
    setErrorStates((prev) => ({ ...prev, [id]: true }));
  };

  const fetchUserPrescriptions = async () => {
    const token = localStorage.getItem("admin_token");
    if (!token) {
      console.error("Token not found! User might not be authenticated.");
      return;
    }

    setLoading(true); // Start loading

    try {
      let result = await axios.get(`${api_url}/prescriptions`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

  
      setUserPrescriptions(result.data?.data || []);
    } catch (error) {
      console.error(
        "Error fetching user orders:",
        error.response ? error.response.data : error.message
      );
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchUserPrescriptions();
  }, []);

  const deletePrescription = async (prescription_id) => {
    try {
      await axios.delete(`${api_url}/admin-prescription/${prescription_id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("admin_token"),
        },
      });
      toast.success("Prescription deleted successfully");
      setShowDeleteModal(false);
      setPrescriptionToDelete(null);
      fetchUserPrescriptions();
    } catch (err) {
      toast.error("Failed to delete prescription");
      setShowDeleteModal(false);
      setPrescriptionToDelete(null);
      console.error(err);
    }
  };

  // Update order status locally
  const updateOrderStatus = (id, status) => {
    const updatedOrders = orders.map((order) =>
      order.id === id ? { ...order, status } : order
    );
    setOrders(updatedOrders);
    setSelectedOrder(null);
  };



  const fetchUpdateStatus = async (
    prescription_id,
    newStatus,
    rejectionReason,
    rejectionComments,
    comments
  ) => {
    try {
      if (!newStatus) {
        alert("Please select a status.");
        return;
      }

      let body = { status: newStatus };
      if (newStatus === "Rejected") {
        body.rejection_reason = rejectionReason;
        body.rejection_criteria = rejectionComments;
      }
      if (comments && comments.trim() !== "") {
        body.comments = comments;
      }

      const { data } = await axios.patch(
        `${api_url}/prescription/${prescription_id}`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("admin_token"),
          },
        }
      );

      setOrders(data.data);
      setTrigger(!trigger);
      setSelectedOrder(null);
      toast.success("Update Success");
      fetchUserPrescriptions();
    } catch (e) {
      console.error(
        "Error occurred during status update:",
        e.response ? e.response.data : e.message
      );
      alert("An error occurred while updating the status.");
    }
  };



  // Reset Filters
  const resetFilters = () => {
    setFilters({
      date: "",
      status: "", // Fixed status reset
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);

    return () => clearTimeout(timer);
  }, [filters]);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
          <ToastContainer />
          
      <h1 className="text-2xl font-bold mb-4">Prescriptions List</h1>

      <div className="flex gap-4 mb-6">
    
      <AddToCartModal
        show={showAddToCartModal}
        onClose={() => {
          setShowAddToCartModal(false)
          fetchUserPrescriptions()
        }}
        onAddAgain={() => setShowAddToCartModal(true)}
        prescription={selectedPrescriptionForCart}
        userId={selectedPrescriptionForCart?.user?.id || selectedPrescriptionForCart?.user_id}
        prescription_id={selectedPrescriptionForCart?.prescription_id}
        onSubmit={(items) => {   
          setShowAddToCartModal(false);
        }}
      />
        {/* Date Filter */}
        <input
          type="date"
          className="p-2 border border-gray-300 rounded"
          value={filters.date}
          onChange={(e) => setFilters({ ...filters, date: e.target.value })}
          max={new Date().toISOString().split("T")[0]}
        />

        {/* Status Filter */}
        <select
          className="p-2 border border-gray-300 rounded"
          value={filters.status}
          onChange={(e) => setFilters({ ...filters, status: e.target.value })}
        >
          <option value="">All Status</option>
          <option value="Prescription_Uploaded">Prescription Uploaded</option>
   <option value="AddedToCart">Added to Cart</option>
          <option value="Pending">Pending</option>
          <option value="InReview">In Review</option>
          <option value="Approved">Approved</option>
          <option value="Rejected">Rejected</option>
          <option value="Cancelled">Cancelled</option>
        </select>

        {/* Reset Button */}
        <button
          className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          onClick={resetFilters}
        >
          Reset Filters
        </button>

        {/* Export Button */}
        <div className="bg-green-500 flex items-center px-5 rounded-lg hover:text-white cursor-pointer hover:bg-green-400 transition-all duration-400 hover:scale-x-105">
          <DownloadTableExcel
            filename="Prescriptions_List"
            sheet="prescriptions"
            currentTableRef={tableRef.current}
          >
            <button>Export Excel</button>
          </DownloadTableExcel>
        </div>
      </div>
      {showStatusHistoryModal && statusHistoryPrescription && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4 relative">
            <div className="flex justify-between items-center border-b p-4">
              <h2 className="text-lg font-semibold">
                Prescription Status History
              </h2>
              <button
                className="text-2xl leading-none text-gray-500 hover:text-gray-700"
                onClick={() => setShowStatusHistoryModal(false)}
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            <div className="p-6">
              <p className="mb-2">
                <span className="font-bold">Prescription ID:</span>{" "}
                {statusHistoryPrescription.prescription_sequential_id ||
                  statusHistoryPrescription.prescription_id ||
                  statusHistoryPrescription.id}
              </p>
              <p className="mb-4">
                <span className="font-bold">Current Status:</span>{" "}
                {statusHistoryPrescription.status}
              </p>
              {Array.isArray(
                statusHistoryPrescription.PrescriptionStatusHistory
              ) &&
              statusHistoryPrescription.PrescriptionStatusHistory.length > 0 ? (
                <div className="overflow-x-auto max-h-96 overflow-y-auto">
                  <table className="table-auto w-full text-left border-collapse text-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="p-2 border">Old Status</th>
                        <th className="p-2 border">New Status</th>
                        <th className="p-2 border">Comments</th>
                        <th className="p-2 border">Updated By</th>
                           <th className="p-2 border">User Type</th>
                        <th className="p-2 border">Updated Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statusHistoryPrescription.PrescriptionStatusHistory.map(
                        (h, idx) => {
                          const updatedBy =
                            h.UserType === "ADMIN_USER"
                              ? h.updatedByAdmin?.name || "Admin"
                              : h.updatedByUser?.name || "User";
                          return (
                            <tr key={idx}>
                              <td className="p-2 border capitalize">
                                {h.old_status}
                              </td>
                              <td className="p-2 border capitalize">
                                {h.new_status}
                              </td>
                               <td className="p-2 border capitalize">
                                {h.comments || "N/A"}
                              </td>
                              <td className="p-2 border">{updatedBy}</td>
                                <td className="p-2 border">{h.UserType}</td>
                              <td className="p-2 border">
                                {new Date(h.updated_at).toLocaleString()}
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                <span className="text-gray-500">No status history</span>
              )}
            </div>
          </div>
        </div>
      )}

      {showViewModal && viewPrescription && (
        <div className="fixed top-0 right-0 w-full md:w-1/2 h-full bg-white shadow-2xl z-50 overflow-y-auto transition-all duration-300 border-l border-gray-200">
          <div className="flex justify-between items-center p-4 border-b">
            <h2 className="text-xl font-bold">Prescription Details</h2>
            <button
              className="text-gray-500 hover:text-red-600 text-2xl font-bold"
              onClick={() => setShowViewModal(false)}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <div className="p-6">
            <table className="table-auto w-full text-left border-collapse">
              <tbody>
                <tr>
                  <td className="font-semibold p-2 border">Prescription ID</td>
                  <td className="p-2 border">
                    {viewPrescription.prescription_sequential_id ||
                      `MSP-PN-000${viewPrescription.id}`}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold p-2 border">Date</td>
                  <td className="p-2 border">
                    {new Date(viewPrescription.created_at).toLocaleString()}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold p-2 border">Username</td>
                  <td className="p-2 border">{viewPrescription.user?.name || "N/A"}</td>
                </tr>
                <tr>
                  <td className="font-semibold p-2 border">Phone No</td>
                  <td className="p-2 border">
                    {viewPrescription.user?.mobile_number || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold p-2 border">
                    Prescription Image
                  </td>
                  <td className="p-2 border">
                  <div className="space-y-4 w-[90px]">
                        {!errorStates[viewPrescription.prescription_id] ? (
                          <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            to={viewPrescription.image_url}
                          >
                            <img
                              src={viewPrescription.image_url}
                              alt="prescription"
                              onError={() => handleImageError(viewPrescription.prescription_id)}
                              className="w-full h-auto rounded"
                            />
                          </Link>
                        ) : (
                          <a
                            href={viewPrescription.image_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-full h-[100px] flex items-center justify-center bg-gray-100 border rounded text-xs text-gray-700"
                          >
                            View File
                          </a>
                        )}
                      </div>
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold p-2 border">Notes</td>
                  <td className="p-2 border">
                    {viewPrescription.description_notes || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold p-2 border">Status</td>
                  <td className="p-2 border">
                    {" "}
                    <p className="font-normal mb-2">
                      <span className="font-bold">Current Status: </span>
                      {viewPrescription.status}
                    </p>
                    {Array.isArray(
                      viewPrescription.PrescriptionStatusHistory
                    ) &&
                    viewPrescription.PrescriptionStatusHistory.length > 0 ? (
                      <div className="overflow-x-auto">
                        <table className="table-auto w-full text-left border-collapse text-sm">
                          <thead className="bg-gray-100">
                            <tr>
                              <th className="p-2 border whitespace-nowrap">
                                Old&nbsp;Status
                              </th>
                              <th className="p-2 border whitespace-nowrap">
                                New&nbsp;Status
                              </th>
                              <th className="p-2 border whitespace-nowrap">
                                Comments
                              </th>
                              <th className="p-2 border whitespace-nowrap">
                                Updated&nbsp;By
                              </th>
                              <th className="p-2 border whitespace-nowrap">
                                Updated&nbsp;Time
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {viewPrescription.PrescriptionStatusHistory.map(
                              (h, idx) => {
                                const updatedBy =
                                  h.UserType === "ADMIN_USER"
                                    ? h.updatedByAdmin?.name || "Admin"
                                    : h.updatedByUser?.name || "User";

                                return (
                                  <tr key={idx}>
                                    <td className="p-2 border capitalize">
                                      {h.old_status}
                                    </td>
                                    <td className="p-2 border capitalize">
                                      {h.new_status}
                                    </td>
                                    <td className="p-2 border">
                                      {h.comments || "N/A"}
                                    </td>
                                    <td className="p-2 border">{updatedBy}</td>
                                    <td className="p-2 border">
                                      {new Date(h.updated_at).toLocaleString()}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <span className="text-gray-500">No status history</span>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold p-2 border align-top">
                    Uploaded Medicine Images
                  </td>
                  <td className="p-2 border">
                    {Array.isArray(viewPrescription.PrescriptionImage) &&
                    viewPrescription.PrescriptionImage.length > 0 ? (
                      <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
                        {viewPrescription.PrescriptionImage.slice(0, 10).map(
                          (img) => (
                            <a
                              key={img.image_id}
                              href={img.image_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={img.image_url}
                                alt="Medicine"
                                className="w-20 h-20 object-cover rounded border hover:scale-105 hover:shadow-lg transition-all duration-200"
                              />
                            </a>
                          )
                        )}
                      </div>
                    ) : (
                      <span className="text-gray-500">No images uploaded</span>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Orders Table */}
      <div className="overflow-x-auto text-xs bg-white h-[700px] overflow-y-scroll py-10 px-2 rounded-xl">
        <table
          className="table-auto w-full border-collapse border border-gray-200"
          ref={tableRef}
        >
          <thead>
            <tr className="bg-gray-200 rounded-tr-lg">
              <th className="p-4 first:rounded-tl-lg max-w-[90px]">
                Prescription ID
              </th>
              <th className="p-4 border">Date</th>
              <th className="p-4 border">Username</th>
              {/* <th className="p-4 border max-w-[70px]">Billing Address</th> */}
              <th className="p-4 border">Phone No</th>
              <th className="p-4 border">Prescription</th>
              <th className="p-4 border">Notes</th>

              <th className="p-4 border">Status</th>
              <th className="p-4 border last:rounded-tr-xl">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="8"
                  className="p-4 text-center text-gray-500 animate-pulse"
                >
                  Loading orders...
                </td>
              </tr>
            ) : (
              userPrescriptions
                .filter((order) => {
                  // Convert created_at date to YYYY-MM-DD for filtering
                  const orderDate = new Date(order.created_at)
                    .toISOString()
                    .split("T")[0];

                  // Apply date filter (if selected)
                  if (filters.date && orderDate !== filters.date) return false;

                  // Apply status filter (if selected)
                  if (
                    filters.status &&
                    order.status.toLowerCase() !== filters.status.toLowerCase()
                  )
                    return false;

                  return true;
                })
                .map((order) => (
                  <tr key={order.id} className="odd:bg-white even:bg-gray-50">
                    <td className="p-4 border text-left text-sm font-medium max-w-[100px] break-words">
                      {order.prescription_sequential_id ||
                        `MSP-PN-000${order.id}`}
                    </td>
                    <td className="p-4 border text-left text-sm max-w-[120px] break-words">
                      {new Date(order.created_at).toLocaleString()}
                    </td>
                    <td className="p-4 border text-left text-sm">
                      {order.user.name}
                    </td>
                    {/* <td className="p-4 border text-left text-sm max-w-[120px] break-words">
                {order?.user?.addresses?.length > 0 ? (
                  <>
                    {order.user.addresses.map((address) => (
                      <div key={address.id} className="mb-2">
                        <span className="block font-semibold">{address.deliver_to}</span>
                        <span>{address.city}, {address.state}</span>
                        <br />
                        <span className="text-sm text-gray-500">Pincode: {address.pincode}</span>
                      </div>
                    ))}
                  </>
                ) : (
                  <span className="text-sm text-gray-500">No Shipping Address</span>
                )}
              </td> */}
                    <td className="p-4 border text-sm">
                      {order.user.mobile_number || "N/A"}
                    </td>
                    <td key={order.id} className="p-4 border">
                      <div className="space-y-4 w-[90px]">
                        {!errorStates[order.id] ? (
                          <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            to={order.image_url}
                          >
                            <img
                              src={order.image_url}
                              alt="prescription"
                              onError={() => handleImageError(order.id)}
                              className="w-full h-auto rounded"
                            />
                          </Link>
                        ) : (
                          <a
                            href={order.image_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block w-full h-[100px] flex items-center justify-center bg-gray-100 border rounded text-xs text-gray-700"
                          >
                            View File
                          </a>
                        )}
                      </div>
                    </td>
                    <td className="p-4 border">
                      {order.description_notes || "N/A"}
                    </td>

                    <td className="p-4 border w-60">
                      <div className="flex flex-row gap-2">
                        <button
                          className={`px-2 py-1 text-sm font-normal rounded-full focus:outline-none transition hover:scale-105 
                          ${
                            order.status === "Rejected"
                              ? "bg-red-600 text-white"
                              : order.status === "Approved"
                              ? "bg-green-600 text-white"
                              : order.status === "InReview"
                              ? "bg-yellow-600 text-white"
                              : order.status === "AddedToCart"
                              ? "bg-green-800 text-white"
                              : "bg-gray-300 text-gray-800"
                          }`}
                          title="View Status History"
                          onClick={() => {
                            const pres = userPrescriptions.find(
                              (p) =>
                                p.id === order.prescription_id ||
                                p.prescription_id === order.prescription_id
                            );
                            setStatusHistoryPrescription(pres || null);
                            setShowStatusHistoryModal(true);
                          }}
                        >
                          {order.status}
                        </button>

                        {order.status === "AddedToCart" && (
                          <button
                            onClick={() => {
                              console.log("button clicked");
                              setShowViewCart(true);
                              setShowCartItem(order.PrescriptionCart);
                            }}
                            className="px-2 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-md transition-all duration-200 ease-in-out"
                          >
                            View Cart
                          </button>
                        )}
                      </div>

                    </td>

                    <td className="p-4 border">
                      <div className="flex items-center space-x-2">
                        { (role !== "EMPLOYEE" || order.status !== "AddedToCart") && (
                          <PencilSquareIcon
                            className="h-5 w-5 text-yellow-900 cursor-pointer hover:text-yellow-600"
                            onClick={() => setSelectedOrder(order)}
                          />
                        )}
                        {/* {role === "ADMIN" && (
                          <TrashIcon
                            className="h-5 w-5 text-red-600 cursor-pointer hover:text-red-800"
                            onClick={() => {
                              setPrescriptionToDelete(order.prescription_id);
                              setShowDeleteModal(true);
                            }}
                          />
                        )} */}
                        <FaEye
                          className="h-5 w-5 text-blue-600 cursor-pointer hover:text-blue-800"
                          onClick={() => {
                            setViewPrescription(order);
                            setShowViewModal(true);
                          }}
                        />
                      </div>
                      <div className="flex items-center space-x-2 mt-4">
                        {order.status==="Approved" && (
                        <button
                          className="px-1 py-2 text-xs font-normal text-white bg-blue-600 rounded hover:bg-blue-700"
                          onClick={() => {
                            setSelectedPrescriptionForCart(order);
                            setShowAddToCartModal(true);
                          }}
                        >
                          Add to Cart
                        </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
            )}
            {/* No Results Found */}
            {!loading &&
              userPrescriptions.filter((order) => {
                const orderDate = new Date(order.created_at)
                  .toISOString()
                  .split("T")[0];
                return (
                  (!filters.date || orderDate === filters.date) &&
                  (!filters.status ||
                    order.status.toLowerCase() === filters.status.toLowerCase())
                );
              }).length === 0 && (
                <tr>
                  <td colSpan="8" className="p-4 text-center text-gray-500">
                    No Prescriptions found.
                  </td>
                </tr>
              )}
          </tbody>
        </table>
      </div>

     
      {selectedOrder && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl w-96">
            <h2 className="text-lg font-bold text-gray-800 mb-4">
              Update Status for Prescription #{selectedOrder.prescription_sequential_id}
            </h2>

            {/* Status Dropdown */}
            <select
              className="w-full p-2 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-[#5FBDB3]"
              value={newStatus}
              onChange={(e) => setNewStatus(e.target.value)}
            >
              <option value="" disabled>
                Select Status
              </option>
        

            {Object.entries(statusOptions).map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}

            </select>

        
            {newStatus === "Rejected" && (
              <>
                {/* Reason Dropdown */}
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Reason for Rejection
                </label>
                <select
                  className="w-full p-2 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-[#5FBDB3]"
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                >
                  <option value="" disabled>
                    Select Reason
                  </option>
                  <option value="illegible_handwriting">
                    Illegible Handwriting
                  </option>
                  <option value="missing_information">
                    Missing Information
                  </option>
                  <option value="outdated_documents">Outdated Documents</option>
                </select>

                {/* Comments Textarea */}
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Comments for Rejection
                </label>
                <textarea
                  className="w-full p-2 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-[#5FBDB3]"
                  rows="3"
                  placeholder="Add additional comments here..."
                  value={rejectionComments}
                  onChange={(e) => setRejectionComments(e.target.value)}
                ></textarea>
              </>
            )}
             <label className="block text-sm font-medium text-gray-700 mb-1">
                  Comments (optional)
             </label>
              <textarea 
              type="text"
              className="w-full p-2 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-[#5FBDB3]"
              placeholder="Add comments here..."
              value={comments}
              rows="3"
              onChange={(e) => setComments(e.target.value)}
              />
            {/* Buttons */}
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300"
                onClick={() => setSelectedOrder(null)}
              >
                Cancel
              </button>
              <button
                className={`px-4 py-2 text-white rounded-lg ${
                  newStatus
                    ? "bg-[#5FBDB3] hover:bg-[#3d7b74]"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
                onClick={() => {
                  if (!newStatus) {
                    alert("Please select a status before updating.");
                    return;
                  }

                  if (
                    newStatus === "Rejected" &&
                    (!rejectionReason || rejectionComments.trim() === "")
                  ) {
                    alert(
                      "Please provide both a reason and comments for rejection."
                    );
                    return;
                  }
                  fetchUpdateStatus(
                    selectedOrder.prescription_id,
                    newStatus,
                    rejectionReason,
                    rejectionComments,
                    comments
                  );
                }}
                disabled={!newStatus}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

       {showViewCart && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-[600px] max-h-[80vh] overflow-y-auto">
            <h2 className="text-lg font-bold text-green-700 mb-4">
              Products Added to User Cart
            </h2>

            <div className="grid grid-cols-3 gap-6">
              {showCartItem.filter((item) => item.status === "Added").length === 0 ? (
                <div className="col-span-3 text-center text-gray-500 py-6">
                  No product data found
                </div>
              ) : (
                showCartItem
                  .filter((item) => item.status === "Added")
                  .map((item) => (
                    <div
                      key={item.id}
                      className="border border-green-400 bg-green-50 rounded-xl p-3 flex flex-col items-center shadow-sm"
                    >
                      {item.product?.product_images?.image_url?.primary_image ? (
                        <img
                          src={item.product.product_images.image_url.primary_image}
                          alt={item.product.name}
                          className="w-20 h-20 object-contain rounded"
                        />
                      ) : (
                        <div className="w-20 h-20 rounded bg-gray-200 flex items-center justify-center text-gray-500">
                          No Img
                        </div>
                      )}

                      <p className="font-semibold text-sm mt-2">{item.product?.name}</p>
                      <p className="text-xs text-gray-600">Qty: {item.quantity}</p>
                      <p className="text-xs text-gray-700">Price: ₹{item.price}</p>
                      <p className="text-xs font-medium text-green-700">
                        Total: ₹{item.total_price}
                      </p>
                    </div>
                  ))
              )}
            </div>

            {/* Close button */}
            <button
              className="mt-6 px-4 py-2 bg-red-600 text-white rounded-lg w-full"
              onClick={() => {
                setShowCartItem("")
                setShowViewCart(false)
              }
              }
            >
              Close
            </button>
          </div>
        </div>
      )}
    {/* Delete Confirmation Modal */}
      <DeletePrompt
        showModal={showDeleteModal}
        onDelete={() => prescriptionToDelete && deletePrescription(prescriptionToDelete)}
        onCancel={() => {
          setShowDeleteModal(false);
          setPrescriptionToDelete(null);
        }}
      />

      
    </div>
  );
};

export default PrescriptionList;
